// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { calender_icon } from "../../assets/img";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";
import moment from "moment";

const DateRange = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  paginationPath,
  hideToRange,
  disabled,
  fromValue,
  toValue,
  isneed,
  currentDay,
}) => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = paginationPath ?? location.pathname?.replace("/", "");
  const [selectedDates, setSelectedDates] = useState({
    from:
      (paginationData?.[path]?.from ?? currentDay)
        ? moment().startOf("day").format("YYYY-MM-DD")
        : "",
    to:
      (paginationData?.[path]?.to ?? currentDay)
        ? moment().startOf("day").format("YYYY-MM-DD")
        : "",
  });
  useEffect(() => {
    if (!disabled) {
      setFromDate?.(selectedDates?.from);
      setToDate?.(selectedDates?.to);
      setpaginationData((prev) => ({
        ...prev,
        [path]: {
          ...prev?.[path],
          from: selectedDates?.from,
          to: selectedDates?.to,
        },
      }));
    }
  }, [selectedDates.from, selectedDates.to]);

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const openFromDatePicker = () => {
    if (fromDateRef.current && !disabled) {
      fromDateRef.current.showPicker?.() || fromDateRef.current.click();
    }
  };
  console.log("from date", fromDate);
  const openToDatePicker = () => {
    if (toDateRef.current && !disabled) {
      toDateRef.current.showPicker?.() || toDateRef.current.click();
    }
  };
  return (
    <div className="d-flex ac-jb gap-2">
      {/* From Date */}
      <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
        <img
          src={calender_icon}
          className="calender-icon me-2"
          alt="calendar"
          onClick={openFromDatePicker}
          style={{ cursor: "pointer" }}
        />
        <div style={{ width: "115px" }}>
          <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
            From Range:
          </p>
          <input
            ref={fromDateRef}
            type="date"
            value={fromValue ?? selectedDates.from}
            disabled={disabled}
            onChange={(e) => {
              setSelectedDates({ from: e.target.value, to: "" });
              setFromDate?.(e.target.value);
            }}
            className="border-0 w-100"
            placeholder="From Date"
          />
        </div>
      </div>

      {/* To Date */}
      {!hideToRange && (
        <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
          <img
            src={calender_icon}
            className="calender-icon me-2"
            alt="calendar"
            onClick={openToDatePicker}
            style={{ cursor: "pointer" }}
          />
          <div style={{ width: "115px" }}>
            <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
              To Range:
            </p>
            <input
              ref={toDateRef}
              type="date"
              min={selectedDates.from ?? null}
              value={toValue ?? selectedDates?.to}
              onChange={(e) => {
                setSelectedDates((prev) => ({ ...prev, to: e.target.value }));
                setToDate?.(e.target.value);
              }}
              disabled={disabled}
              className="border-0 w-100"
              placeholder="To Date"
            />
          </div>
        </div>
      )}
      {!isneed && (
        <button
          onClick={() => {
            if (currentDay) {
              let today = moment().startOf("day").format("YYYY-MM-DD");
              setSelectedDates({ from: today, to: today });
              setFromDate?.(today);
              setToDate?.(today);
            } else {
              setSelectedDates({ from: "", to: "" });
              setFromDate?.("");
              setToDate?.("");
            }
          }}
          className="f2 fs-sm-6 fs-md-8 fs-lg-10 fs-xl-10 fs-xxl-12 white add-btn "
        >
          Reset Date
        </button>
      )}
    </div>
  );
};

export default DateRange;
